<template>
  <div class="form-item">
    <label v-if="label" class="label">{{ label }}</label>

    <select
      class="select-input"
      name="selectInput"
      @change="handleInput"
      :value="value"
      v-if="items && items.length > 0"
    >
      <option disabled selected value="">Please select one</option>
      <option v-for="(item, key) in items" :key="key" :value="item.id">{{
        item.name
      }}</option>
    </select>
    <p v-else>No items found</p>
    <small v-if="error" class="error">{{ error }}</small>
  </div>
</template>

<script>
/* eslint-disable */
// import { mapGetters, mapActions } from "vuex";

export default {
  name: "ArnergyInput",
  props: {
    model: null,
    placeholder: null,
    label: null,
    disabled: false,
    type: "text",
    items: null,
    error: null,
    value:{}
  },
  computed: {},
  data() {
    return {};
  },
  methods: {
    handleInput(event) {
      this.$emit("input", event.target.value);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/_reduced_variables.scss";
.form-item {
  margin-bottom: 20px;

  label {
    margin-bottom: 10px;
    color: #999;
    font-size: 14px;
    padding: 0;
    font-weight: 400;
    display: block;
    text-align: left;
  }

  .select-input {
    border: 1px solid #cccccc;
    width: 100%;
    padding: 10px 20px;
    height: 60px;
    font-weight: bold;
  }

  input,
  .input {
    width: 100%;
    display: block;
    height: 50px;
    padding: 20px;
    font-weight: bold;
    border: 1px solid #cccccc;
  }

  .error {
    color: red;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/kitchen/ArnergySelect.vue